/**
 * @generated SignedSource<<bbe93148edaa563a1be1fda12bc24382>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
export type GetForumCategoriesQuery$variables = Record<PropertyKey, never>;
export type GetForumCategoriesQuery$data = {
  readonly unified: {
    readonly ai: {
      readonly getForumCategories: {
        readonly __typename: "UnifiedAiCategoriesResult";
        readonly categories: ReadonlyArray<{
          readonly created_at: string;
          readonly description: string | null | undefined;
          readonly href: string;
          readonly id: string;
          readonly is_active: boolean;
          readonly name: string;
          readonly order: number;
          readonly parent_id: string | null | undefined;
          readonly type: string;
          readonly updated_at: string;
        }>;
      } | {
        readonly __typename: "UnifiedQueryError";
        readonly code: string | null | undefined;
        readonly extensions: ReadonlyArray<{
          readonly errorType: string | null | undefined;
          readonly statusCode: number | null | undefined;
        }> | null | undefined;
        readonly identifier: string | null | undefined;
        readonly message: string | null | undefined;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type GetForumCategoriesQuery = {
  response: GetForumCategoriesQuery$data;
  variables: GetForumCategoriesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UnifiedQuery",
    "kind": "LinkedField",
    "name": "unified",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedAiQuery",
        "kind": "LinkedField",
        "name": "ai",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "getForumCategories",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedAiCategory",
                    "kind": "LinkedField",
                    "name": "categories",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "href",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "order",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "parent_id",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "is_active",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "created_at",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "updated_at",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "UnifiedAiCategoriesResult",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "identifier",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "message",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedQueryErrorExtension",
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "statusCode",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "errorType",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "UnifiedQueryError",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "GetForumCategoriesQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "GetForumCategoriesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "fdee52ecaf153d71e4c2eb88c7245699",
    "id": null,
    "metadata": {},
    "name": "GetForumCategoriesQuery",
    "operationKind": "query",
    "text": "query GetForumCategoriesQuery {\n  unified {\n    ai {\n      getForumCategories {\n        __typename\n        ... on UnifiedAiCategoriesResult {\n          categories {\n            id\n            name\n            description\n            href\n            type\n            order\n            parent_id\n            is_active\n            created_at\n            updated_at\n          }\n        }\n        ... on UnifiedQueryError {\n          identifier\n          message\n          code\n          extensions {\n            statusCode\n            errorType\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "761130d036746e963bb77315d71f04e6";

export default node;
